"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeRangePicker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * TimeRangePicker.tsx
 * Author: fwunderlich
 * Date: 21.10.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const Input_1 = require("./Input");
const react_i18next_1 = require("react-i18next");
const TimeRangePicker = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['common']);
    const [internal, setInternal] = (0, react_1.useState)([]);
    const [from, setFrom] = (0, react_1.useState)();
    const [to, setTo] = (0, react_1.useState)();
    const internalFrom = (0, react_1.useRef)();
    const internalTo = (0, react_1.useRef)();
    const changeTriggered = (0, react_1.useRef)(false);
    // useEffect(() => {
    //     return unmount;
    // }, []);
    const unmount = (0, react_1.useCallback)(() => {
        if (internalFrom.current && internalTo.current) {
            if (!changeTriggered.current && props.onChange) {
                props.onChange(internalFrom.current, internalTo.current);
            }
        }
    }, [internalFrom.current, internalTo.current, changeTriggered.current]);
    (0, react_1.useEffect)(() => {
        setFrom(props.from);
        setTo(props.to);
        internalFrom.current = props.from;
        internalTo.current = props.to;
        if (props.from && props.to) {
            setInternal([props.from, props.to]);
        }
    }, [props.from, props.to]);
    (0, react_1.useEffect)(() => {
        // console.log(from, to);
        if (from && to) {
            if (props.onChange) {
                props.onChange(from, to);
                changeTriggered.current = true;
            }
        }
    }, [from, to]);
    (0, react_1.useEffect)(() => {
        return unmount;
    }, []);
    return ((0, jsx_runtime_1.jsx)(Input_1.Input, { className: "w-full", type: "date", name: "datetimepicker", label: props.noLabels ? '' : t('timerange'), edit: true, options: { selectionMode: 'range', showTime: false, readOnlyInput: true }, value: internal.length ? internal : undefined, onChange: (e) => {
            const f = new Date(e.value[0]);
            const t = e.value[1] ? new Date(e.value[1]) : new Date(e.value[0]);
            f.setHours(0);
            f.setMinutes(0);
            f.setSeconds(0);
            internalFrom.current = f;
            t.setHours(23);
            t.setMinutes(59);
            t.setSeconds(59);
            internalTo.current = t;
            setInternal(e.value);
            changeTriggered.current = false;
        }, onBlur: (e) => {
            setFrom(internalFrom.current);
            setTo(internalTo.current);
        } }));
};
exports.TimeRangePicker = TimeRangePicker;
